<template>
  <el-col style="padding: 16px;">
    <el-row :gutter="16">
      <el-col :xs="24" :sm="16">
        <el-card
          :v-loading="publishedUpdates == null"
          shadow="hover"
          class="box-card"
          :body-style="{ padding: '8px', 'padding-top': '0px', height: window.height - 161 + 'px', 'position': 'relative'}"
        >
          <div slot="header" class="clearfix">
            <span>Updates</span>
            <el-tooltip placement="top">
              <div slot="content">
                All published updates
                <br />will appear here.
              </div>
              <i class="el-icon-question info-hover"></i>
            </el-tooltip>
            <el-button @click="createUpdate" style="float: right; padding: 3px 0" type="text">New</el-button>
          </div>
          <span
            v-if="publishedUpdates == null || publishedUpdates.data.length == 0"
            class="center-message"
          >No Updates</span>
          <div
            :style="{ height: (window.height) - 205 + 'px', 'overflow-y': 'scroll', 'position': 'relative'}"
            v-else
          >
            <div v-bind:style="{ 'height': 'window.height - 150'}">
              <div
                class="list-tile"
                v-for="update in publishedUpdates.data"
                :key="update.o_id"
                @click="showUpdate(update, true)"
              >
                <span class="list-title">{{update.update_title}}</span>
                <div style="display: flex">
                  <span
                    class="list-subtext"
                    style="margin-right: auto;"
                  >{{getFullName(update.user)}}</span>
                  <span class="list-subtext">{{moment(update.updated_at).fromNow()}}</span>
                </div>
              </div>
            </div>
          </div>
          <el-pagination
            style="line-height: 12px; margin-top: 16px; margin-bottom: 8px; position: absolute; bottom: 0;"
            background
            :hide-on-single-page="true"
            v-if="publishedUpdates"
            layout="prev, pager, next"
            :page-count="publishedUpdates.last_page"
            :current-page="publishedUpdates.current_page"
            @current-change="changePublishedPage"
            @prev-click="changePublishedPage"
            @next-click="changePublishedPage"
          />
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="8">
        <el-row style="margin-bottom: 16px;">
          <el-card
            :v-loading="approvalUpdates == null"
            shadow="hover"
            class="box-card"
            :body-style="{ padding: '8px', 'padding-top': '0px', height: (window.height/2) - 123 + 'px', 'position': 'relative' }"
          >
            <div slot="header" class="clearfix">
              <span>Approvals</span>
              <el-tooltip placement="top">
                <div slot="content">
                  Updates that require your approval
                  <br />will appear here.
                </div>
                <i class="el-icon-question info-hover"></i>
              </el-tooltip>
            </div>
            <span
              v-if="approvalUpdates == null || approvalUpdates.data.length == 0"
              class="center-message"
            >No Approvals Needed</span>
            <div
              :style="{ height: (window.height/2) - 169 + 'px', 'overflow-y': 'scroll', 'position': 'relative'}"
              v-else
            >
              <div
                class="list-tile"
                v-for="update in approvalUpdates.data"
                :key="update.o_id"
                @click="showUpdate(update, false)"
              >
                <span v-if="update != null" class="list-title">{{update.update_title}}</span>
                <div v-if="update != null" style="display: flex">
                  <span
                    class="list-subtext"
                    style="margin-right: auto;"
                  >{{getFullName(update.user)}}</span>
                  <span class="list-subtext">{{moment(update.updated_at).fromNow()}}</span>
                </div>
              </div>
            </div>
            <el-pagination
              v-if="approvalUpdates"
              :hide-on-single-page="true"
              style="line-height: 12px; margin-top: 16px; margin-bottom: 8px; position: absolute; bottom: 0;"
              background
              layout="prev, pager, next"
              :page-count="approvalUpdates.last_page"
              :current-page="approvalUpdates.current_page"
              @current-change="changeApprovalPage"
              @prev-click="changeApprovalPage"
              @next-click="changeApprovalPage"
            />
          </el-card>
        </el-row>
        <el-row>
          <el-card
            :v-loading="selfUpdates == null"
            shadow="hover"
            class="box-card"
            :body-style="{ padding: '8px', 'padding-top': '0px', height: (window.height/2) - 122 + 'px', 'position': 'relative' }"
          >
            <div slot="header" class="clearfix">
              <span>Submitted</span>
              <el-tooltip placement="top">
                <div slot="content">
                  Updates that you submitted
                  <br />will appear here.
                </div>
                <i class="el-icon-question info-hover"></i>
              </el-tooltip>
            </div>
            <span
              v-if="selfUpdates == null || selfUpdates.data.length == 0"
              class="center-message"
            >No Submissions</span>
            <div
              :style="{ height: (window.height/2) - 168 + 'px', 'overflow-y': 'scroll', 'position': 'relative'}"
              v-else
            >
              <div
                class="list-tile"
                v-for="update in selfUpdates.data"
                :key="update.o_id"
                v-loading="positions == null && !update.approved"
                @click="showUpdate(update, false)"
              >
                <div v-if="update != null" style="display: flex">
                  <span class="list-title" style="margin-right: auto;">{{update.update_title}}</span>
                  <el-tooltip
                    v-if="!update.approved && update.approver_position != null"
                    :content="positions == null ? '' : 'Awaiting approval by ' + getPosition(update.approver_position)"
                    placement="top"
                  >
                    <el-tag
                      style="margin-top: 8px; margin-left: 8px;"
                      size="small"
                      type="warning"
                    >Approval</el-tag>
                  </el-tooltip>
                  <el-tag
                    v-else
                    style="margin-top: 8px; margin-left: 8px;"
                    size="small"
                    :type="update.published ? 'success' : 'warning'"
                  >{{update.published ? 'Published' : update.approved ? 'Pending' : 'Approval'}}</el-tag>
                </div>
                <div v-if="update != null" style="display: flex">
                  <span
                    class="list-subtext"
                    style="margin-right: auto;"
                  >{{getFullName(update.user)}}</span>
                  <span class="list-subtext">{{moment(update.updated_at).fromNow()}}</span>
                </div>
              </div>
            </div>
            <el-pagination
              v-if="selfUpdates"
              :hide-on-single-page="true"
              style="line-height: 12px; margin-top: 16px; margin-bottom: 8px; position: absolute; bottom: 0;"
              background
              layout="prev, pager, next"
              :page-count="selfUpdates.last_page"
              :current-page="selfUpdates.current_page"
              @current-change="changeSelfPage"
              @prev-click="changeSelfPage"
              @next-click="changeSelfPage"
            />
          </el-card>
        </el-row>
      </el-col>
    </el-row>

    <nxs-update-edit :dialogVisible="dialogVisible" @close="closeDialog"></nxs-update-edit>
  </el-col>
</template>

<script>
import {mapFields} from "vuex-map-fields";
import nxsUpdateEdit from "../../shared/updates/UpdateEdit.vue";

export default {
    components: {nxsUpdateEdit},
    mounted() {
        this.checkUpdates();
        if (this.$route.params.length != 0 && this.$route.params.id != null) {
            this.getAndShowUpdate(this.$route.params.id);
        }
    },
    created() {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },
    computed: {
        ...mapFields([
            "user",
            "positions",
            "selfUpdates",
            "approvalUpdates",
            "publishedUpdates",
            "currentTerm"
        ])
    },

    watch: {
        currentTerm() {
            this.checkUpdates();
        }
    },
    data() {
        return {
            window: {
                width: 0,
                height: 0
            },
            dialogVisible: false
        };
    },
    methods: {
        closeDialog(updateObj) {
            this.dialogVisible = false;
            if (updateObj != null) {
                this.selfUpdates.data.unshift(updateObj);
            }
        },
        createUpdate() {
            this.dialogVisible = true;
        },
        getPosition(id) {
            if (this.positions == null) return "";
            var temp = this.positions.find((obj) => obj.o_id == id);
            return temp.name;
        },
        changePublishedPage(newPage) {
            this.$store.dispatch(
                "pullPublishedUpdates",
                this.buildTermPageURI(
                    "/api/v1/updates/published",
                    [this.currentTerm],
                    newPage
                )
            );
        },
        changeApprovalPage(newPage) {
            this.$store.dispatch(
                "pullApprovalUpdates",
                this.buildTermPageURI(
                    "/api/v1/updates/approvals",
                    [this.currentTerm],
                    newPage
                )
            );
        },
        changeSelfPage(newPage) {
            this.$store.dispatch(
                "pullSelfUpdates",
                this.buildTermPageURI(
                    "/api/v1/updates/self",
                    [this.currentTerm],
                    newPage
                )
            );
        },
        checkUpdates() {
            if (this.currentTerm != null) {
                if (this.positions == null) this.$store.dispatch("pullPositions");
                this.changePublishedPage(1);
                this.changeApprovalPage(1);
                this.changeSelfPage(1);
            }
        },
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        showUpdate(val) {
            this.$router.push("/home/updates/" + val.o_id);
        }
    }
};
</script>
